export default "__VITE_ASSET__Ced4VNGd__"